module.exports = __webpack_public_path__ + "img/dsf_icon.334e482d.png";